import React from 'react';
import { CommentIcon, CommentIconProps } from '../../icons/CommentIcon';
import { HtmlDomId } from '../../constants';
import { Typography, TypographyProps } from '../../wag-react/components/Typography';
import { Flex } from '../../wag-react/next-components/Flex';
import { Button } from '../../wag-react/next-components/button';
import { theme } from '../../wag-react/themes/base-theme';
export type ArticleNumberOfCommentsAnchorProps = {
  value: number;
  iconProps?: CommentIconProps;
  textProps?: Omit<TypographyProps, 'children'>;
};
export const ArticleNumberOfCommentsAnchor = ({
  value,
  iconProps,
  textProps
}: ArticleNumberOfCommentsAnchorProps) => <Button href={`#${HtmlDomId.ArticleCommentsSection}`} data-sentry-element="Button" data-sentry-component="ArticleNumberOfCommentsAnchor" data-sentry-source-file="index.tsx">
    <Flex alignItems="center" gridGap="8px" color={theme.colors.caribbeanGreen} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <CommentIcon color="inherit" fontSize={['16px', '20px']} {...iconProps} data-sentry-element="CommentIcon" data-sentry-source-file="index.tsx" />
      <Typography display={['block', 'none']} color="inherit" {...textProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {value}
      </Typography>
      <Typography display={['none', 'block']} color="inherit" {...textProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {value && value > 1 ? `${value} comments` : `Comments`}
      </Typography>
    </Flex>
  </Button>;